import { type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  type FetchingItemsState,
  createFetchingItemsSlice,
} from "features/Application/slices/createFetchingItemsSlice";
import { type CustomerView } from "../types/models";

export interface TemplateCustomersState extends FetchingItemsState<CustomerView> {
  customersToAdd: number[];
}

export const initialState: TemplateCustomersState = {
  isLoading: false,
  items: [],
  itemsCount: 0,
  customersToAdd: [],
};

const slice = createFetchingItemsSlice({
  initialState,
  namePayload: {
    entity: ReducerEntityPrefixTypes.TemplateGroups,
    name: "AvailableCustomers",
    namespace: ReducerNamespaceTypes.People,
  },
  reducers: {
    setCustomersToAdd: (state, action: PayloadAction<number[]>) => {
      state.customersToAdd = action.payload;
    },
  },
});

export const { fetchBegin, fetchFailure, fetchSuccess, reset, setCustomersToAdd } = slice.actions;

export default slice.reducer;
